import React from "react";

import { Users } from "react-feather";
import { RouteInfoType } from "../../types/types";
import AuthLayout from "../../layouts/Auth"

import SignIn from "./pages/SignInPage"


const authRoutes = {
    id: "auth",
    path: "/auth",
    name: "Авторизация",
    icon: <Users/>,
    hide: true,
    component: AuthLayout,
    routes: [
        {
            path: "/auth/sign-in",
            name: "Вход",
            component: SignIn
        },
    ]
} as RouteInfoType;


export default authRoutes;
